// Class: motion.easing.Quint

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Quint_QuintEaseIn() {return require("./../../motion/easing/_Quint/QuintEaseIn");}
function motion_easing__$Quint_QuintEaseInOut() {return require("./../../motion/easing/_Quint/QuintEaseInOut");}
function motion_easing__$Quint_QuintEaseOut() {return require("./../../motion/easing/_Quint/QuintEaseOut");}

// Constructor

var Quint = function(){}

// Meta

Quint.__name__ = ["motion","easing","Quint"];
Quint.__isInterface__ = false;
Quint.prototype = {
	
};
Quint.prototype.__class__ = Quint.prototype.constructor = $hxClasses["motion.easing.Quint"] = Quint;

// Init



// Statics


Quint.easeIn = new (motion_easing__$Quint_QuintEaseIn().default)()
Quint.easeInOut = new (motion_easing__$Quint_QuintEaseInOut().default)()
Quint.easeOut = new (motion_easing__$Quint_QuintEaseOut().default)()

// Export

exports.default = Quint;